import classNames from 'classnames';
import styles from './ClosureObjectHeader.module.scss';
import Button from '../../Button';
import { ButtonType } from '../../../utils/@globalTypes';
import { BookingFormType } from '../../../redux/types/bookingTypes';
import { CloseIcon, DeleteIcon, EditIcon } from '../../../assets/icons';
import { FormikProps } from 'formik';

type HeaderProps = {
  windowType: BookingFormType;
  handleClickEdit?: () => void;
  handleSubmit?: () => void;
  handleClickDelete?: () => void;
  formik: FormikProps<any>;
  windowClose: () => void;
};

const ClosureObjectHeader = ({
  windowType,
  handleClickEdit,
  handleClickDelete,
  formik,
  windowClose,
}: HeaderProps) => {
  const { dirty } = formik;

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        Закрыть объект
        {windowType === BookingFormType.edit && (
          <div className={styles.titleAdd}>(Режим редактирования)</div>
        )}
      </div>
      <div className={styles.btnPanel}>
        {windowType === BookingFormType.view && (
          <div className={classNames(styles.btnEdit, styles.desktop)}>
            <Button
              title="Редактировать"
              type={ButtonType.PRIMARY_SMALL}
              onClick={handleClickEdit}
            />
          </div>
        )}
        {windowType === BookingFormType.view && (
          <div className={classNames(styles.btnEdit, styles.mob)}>
            <Button
              type={ButtonType.SMALL}
              title={<EditIcon />}
              onClick={handleClickEdit}
            />
          </div>
        )}

        {windowType !== BookingFormType.new && (
          <div
            className={classNames(
              styles.btnDel,
              styles.desktop,
              styles.btnActiveDel,
            )}
          >
            <Button
              title="Удалить"
              type={ButtonType.PRIMARY_SMALL}
              onClick={handleClickDelete}
              confirmWindowText="Вы действительно хотите удалить запись?"
              className="deleteBookingList"
              windowClassName="bookingFormConfirm"
            />
          </div>
        )}
        {windowType !== BookingFormType.new && (
          <div
            className={classNames(
              styles.btnDel,
              styles.mob,
              styles.btnActiveDel,
            )}
          >
            <Button
              type={ButtonType.SMALL}
              title={<DeleteIcon />}
              wrapperClassName="bookingList"
              windowClassName="bookingFormConfirm"
              onClick={handleClickDelete}
              confirmWindowText="Вы действительно хотите удалить запись?"
            />
          </div>
        )}
        <div className={styles.btnClose} onClick={windowClose}>
          <CloseIcon />
        </div>
      </div>
    </div>
  );
};

export default ClosureObjectHeader;
